import React, { useState, useEffect } from 'react';
import { useDiary, pixelY } from './DiaryContext';
import moment from 'moment';

/**
 * NowIndicator - Red horizontal line showing the current time.
 * Only visible when viewing today's date. Updates every 30 seconds.
 */
function NowIndicator() {
  const { state } = useDiary();
  const { selectedDate, viewStartMinutes, zoomLevel } = state;

  const [tick, setTick] = useState(0);

  const isToday = selectedDate === moment().format('YYYY-MM-DD');

  useEffect(() => {
    if (!isToday) return;
    const interval = setInterval(() => setTick(t => t + 1), 30000);
    return () => clearInterval(interval);
  }, [isToday]);

  if (!isToday) return null;

  // Always read fresh time on each render
  const HEADER_HEIGHT = typeof window !== 'undefined' && window.innerWidth < 768 ? 108 : 96;
  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const top = HEADER_HEIGHT + pixelY(currentMinutes, viewStartMinutes, zoomLevel);

  return (
    <div className="dv2-now-indicator" style={{ top }}>
      <div className="dv2-now-line" />
    </div>
  );
}

export default React.memo(NowIndicator);
